import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import ListDeposits from "./List";
import { DEPOSITS, DebtServicePath } from "utils/constants";
import permissions from "app/permissions";

export const resources = {
  isMenu: true,
  icon: <AccountBalanceWalletIcon />,
  name: DebtServicePath + DEPOSITS,
  title: "Депозити",
  list: <ListDeposits />,
  permission: permissions.canPreviewDeposits,
};
